export class NgxDatatableMessages {
    emptyMessage: string = "";
    totalMessage: string = "";
    selectedMessage: string = "";
}